import api from "./axios";

const messagesApi = {
  getAll: () => api.get("/admin/messages"),

  send: (userId, text) =>
    api.post("/admin/messages", {
      user_id: userId,
      message: text,
      subject: text,
    }),
};

export default messagesApi;
